package ai.wagemix.net.client

import ai.wagemix.net.models.WMAuthActionToken
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.FSRequestBuilder
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

/** `POST /api/v1/email-verifications/confirm`: marks the email of an emailed link's account verified; needs no
 * authorization, so the link works on any device. */
class WMConfirmEmailVerificationRequestBuilder:
    FSRequestBuilder<WMConfirmEmailVerificationRequestBuilder, WMAuthActionToken>() {

    override fun build(): FSRequest<WMAuthActionToken> {
        method(FSRequest.Method.Post)
        replacePathParams("api", "v1", "email-verifications", "confirm")
        acceptJson()
        contentTypeJson()
        return super.build()
    }

    override fun self(): WMConfirmEmailVerificationRequestBuilder = this
}
